module.exports = __webpack_public_path__ + "img/wz-7-1-2.2930089b.jpg";